import {changeFilteredInfo} from "@/utils/data/tableCol/tableUtils";

export const nakedApprovalTableCol = (filterInfo) => {
    filterInfo = changeFilteredInfo(filterInfo)
    return [{
        title: 'Id',
        dataIndex: 'id',
        key: 'id',
    }, {
        title: '模块',
        dataIndex: 'projectInfo.projectModel',
        key: 'projectModel',
        scopedSlots: {
            filterIcon: 'filterIcon',
            filterDropdown: 'filterDropdownModel',
            customRender: 'model',
            filtered: true,
        },
        filteredValue: filterInfo.projectModel || [],
    }, {
        title: '合同号',
        dataIndex: 'projectInfo.contractNo',
        key: 'contractNo',
        scopedSlots: {
            filterIcon: 'filterIcon',
            filterDropdown: 'filterDropdown',
            filtered: true,
            customRender: 'foldInfo'
        },
        filteredValue: filterInfo.contractNo || [],
    }, {
        title: '类型',
        dataIndex: 'projectInfo.projectType',
        key: 'projectType',
        scopedSlots: {
            filterIcon: 'filterIcon',
            filterDropdown: 'filterDropdown',
            filtered: true,
            customRender: 'foldInfo'
        },
        filteredValue: filterInfo.projectType || [],
    },
    //     {
    //     title: '合同数据量',
    //     dataIndex: 'projectInfo.contractNum',
    //     key: 'contractNum',
    //     scopedSlots: {
    //         customRender: 'contractNum'
    //     }
    // },
        {
        title: '交付样本数量',
        dataIndex: 'sampleNum',
        key: 'sampleNum',
    },  {
        title: '样本信息',
        dataIndex: 'sampleInfo',
        key: 'sampleInfo',
        scopedSlots: {
            customRender: 'sampleInfo'
        },
    },
        {
            title: '销售',
            dataIndex: 'projectInfo.salesList',
            key: 'salesName',
            scopedSlots: {
                filterIcon: 'filterIcon',
                filterDropdown: 'filterDropdown',
                filtered: true,
                customRender: 'salesName'
            },
            filteredValue: filterInfo.salesName || [],
        }, {
            title: '客户',
            dataIndex: 'projectInfo.customerList',
            key: 'customerName',
            scopedSlots: {
                filterIcon: 'filterIcon',
                filterDropdown: 'filterDropdown',
                filtered: true,
                customRender: 'customerName'
            },
            filteredValue: filterInfo.customerName || [],
        },
        {
            title: '商务、项目系统信息',
            dataIndex: 'projectSystemInfos',
            key: 'projectSystemInfos',
            children: [
                {
                    title: '合同状态',
                    dataIndex: 'contractTypeInfo',
                    key: 'contractStatus',
                    class:'projectSystemInfos_td',
                    scopedSlots: {
                        customRender: 'projectSystemInfos_contractStatus'
                    },
                },
                {
                    title: '合同分类',
                    dataIndex: 'contractTypeInfo',
                    key: 'contractType',
                    class:'projectSystemInfos_td',
                    scopedSlots: {
                        customRender: 'projectSystemInfos_contractType'
                    },
                },
                {
                    title: '测序平台',
                    dataIndex: 'contractTypeInfo',
                    key: 'sequencingPlatform',
                    class:'projectSystemInfos_td',
                    scopedSlots: {
                        customRender: 'projectSystemInfos_sequencingPlatform',
                    },
                },
                {
                    title: '合同样品数目',
                    dataIndex: 'contractTypeInfo.contractSampleNum',
                    key: 'contractSampleNum',
                    class:'projectSystemInfos_td',
                    scopedSlots: {
                        customRender: 'projectSystemInfos_contractSampleNum',
                    },
                },
                {
                    title: '合同数据量',
                    dataIndex: 'contractTypeInfo.planAmountSet',
                    key: 'contractTypeInfo.planAmountSet',
                    class:'projectSystemInfos_td',
                    scopedSlots: {
                        customRender: 'projectSystemInfos_planAmountSet1'
                    },
                },
                {
                    title: '登记数据量',
                    dataIndex: 'planAmountSet',
                    key: 'planAmountSet',
                    class:'projectSystemInfos_td',
                    scopedSlots: {
                        customRender: 'projectSystemInfos_planAmountSet',
                    },
                },
                {
                    title: '样品数目',
                    dataIndex: 'projectSystemInfos',
                    key: 'projectSystemInfos_sampleNum',
                    class:'projectSystemInfos_td',
                    scopedSlots: {
                        customRender: 'projectSystemInfos_sampleNum',
                    },
                },
                {
                    title: '样品数据量',
                    dataIndex: 'projectSystemInfos',
                    width:100,
                    key: 'projectSystemInfos_dataStatus',
                    class:'projectSystemInfos_td',
                    scopedSlots: {
                        customRender: 'projectSystemInfos_dataEnoughStatus',
                    },
                },
            ]
        },
        {
            title: '发起时间',
            dataIndex: 'createTime',
            key: 'createTime',
        }, {
            title: '原始数据路径',
            dataIndex: 'dataPath',
            key: 'dataPath',
            model:['DATA_RELEASE'],
            scopedSlots: {
                customRender: 'dataPath'
            }
        },
        {
            title: '报告路径',
            dataIndex: 'dataPath',
            key: 'dataPath',
            model:['REPORT_UPLOAD'],
            scopedSlots: {
                customRender: 'dataPath'
            }
        },
        {
            title: '状态',
            dataIndex: 'auditStatus',
            key: 'auditStatus',
            scopedSlots: {
                customRender: 'approvalStatus'
            }
        },
        {
            title: '项目备注',
            dataIndex: 'note',
            key: 'note',
            scopedSlots: {
                customRender: 'remark'
            }
        },


    ]
}
